Vue.component("AudioController", {
    template: `
        <div class="audio-controller" style="position:absolute;" v-if="ready">


            <input type="button" :value="getValue" @click="onToggleAudio" >

        </div>
    `,

    data () {
        return { 
            muted: app.localStore.get("audio").muted,
            ready: false,
            canPlay: false
        }
    },

    mounted () {
        app.radio.$on("audio-controller-muted-true", () => { this.muted = true });
        app.radio.$on("audio-controller-muted-false", () => { this.muted = false });
        app.radio.$on("audio-controller-audio-allowed-to-start-false", () => { 
            this.ready = true;
            this.canPlay = false
        })
        app.radio.$on("audio-controller-audio-allowed-to-start-true", () => { 
            this.ready = true;
            this.canPlay = true
        })
        
    },
    methods: {
        onToggleAudio () {


            this.muted = !this.muted;
            this.muted ? app.radio.$emit("audio-controller-global-mute-true") : app.radio.$emit("audio-controller-global-mute-false")

            if(!this.muted)
                this.canPlay = true;
        }
    },

    computed: {
        getValue() {

   
            if(!this.muted && !this.canPlay)
                return "play";

            
            
            return this.muted ? "play" : "stop"
        }
    }

})